import { render, staticRenderFns } from "./ClientVerificationLocal.vue?vue&type=template&id=652dc49c&scoped=true&"
import script from "./ClientVerificationLocal.vue?vue&type=script&lang=js&"
export * from "./ClientVerificationLocal.vue?vue&type=script&lang=js&"
import style0 from "./ClientVerificationLocal.vue?vue&type=style&index=0&id=652dc49c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652dc49c",
  null
  
)

export default component.exports